import { render, staticRenderFns } from "./following_tab.vue?vue&type=template&id=07d9cfdc"
import script from "./following_tab.vue?vue&type=script&lang=js"
export * from "./following_tab.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports